import { cn } from "@/lib/utils";

const ACTIVE = {
  neutral: "border-foreground/25 bg-secondary text-foreground",
  info: "border-info/40 bg-info/10 text-foreground",
  warning: "border-warning/40 bg-warning/10 text-foreground",
  success: "border-success/40 bg-success/10 text-foreground",
  danger: "border-athlynx/40 bg-athlynx/10 text-foreground",
};
const BADGE = {
  neutral: "border-foreground/25 text-foreground",
  info: "border-info/40 text-info",
  warning: "border-warning/40 text-warning",
  success: "border-success/40 text-success",
  danger: "border-athlynx/40 text-athlynx",
};

export default function StatusTabs({ tabs, value, onChange, containerTestId, className }) {
  return (
    <div className={cn("flex gap-1.5 overflow-x-auto scroll-thin pb-0.5 max-w-full", className)} role="tablist" data-testid={containerTestId}>
      {tabs.map((t) => {
        const tone = t.tone || "neutral";
        return (
          <button key={t.id} role="tab" aria-selected={value === t.id}
            onClick={() => onChange(t.id)} data-testid={t.testid}
            className={cn("shrink-0 inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm font-medium border transition-colors",
              value === t.id ? ACTIVE[tone] : "border-border text-muted-foreground hover:text-foreground hover:bg-secondary/60")}>
            {t.label}
            <span className={cn("text-[11px] tabular-nums rounded-full px-1.5 py-px border",
              value === t.id ? BADGE[tone] : "border-border")} data-testid={t.countTestid}>
              {t.count ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
}
